export default __webpack_public_path__ + "ded0ae4c99dac1b567cdaf966a145dbb.png";